import Cookies from "universal-cookie";
import validateToken from "../services/validateToken";

export default (jwt) => {
  document.cookie = `syserrepar_JWT2=${jwt}; path=/; domain=.errepar.com; max-age=43200; SameSite=None; Secure`;
};

//Secure
//domain=.errepar.com;
// Verifica si existe una cookie
const verifyCookie = async () => {
  const cookie = new Cookies();
  const jwt2 = cookie.get("syserrepar_JWT2");

  console.log("JWT:::", jwt2);
  if (!jwt2) return null;
  const validate = await validateToken(jwt2);

  if (validate) {
    /* cookie.set("MiErrepar_JWT2", jwt2, {
      domain: ".errepar.com",
    });*/
    return jwt2;
  }

  return null;
};

const deleteCookie = () => {
  const cookie = new Cookies();
  cookie.remove("syserrepar_JWT2", {
    domain: ".errepar.com",
    path: "/",
  });

  cookie.remove("MiErrepar_JWT2", {
    domain: ".errepar.com",
    path: "/",
  });

  cookie.remove("ApiAuthorizeResponseactivo", {
    domain: ".errepar.com",
    path: "/",
  }); 

  cookie.remove("ApiAuthorizeResponseidUsuario", {
    domain: ".errepar.com",
    path: "/",
  });

  cookie.remove("ApiAuthorizeResponsenombre", {
    domain: ".errepar.com",
    path: "/",
  });

  cookie.remove("ApiAuthorizeResponsesuscriptor", {
    domain: ".errepar.com",
    path: "/",
  });

  cookie.remove("MiErrepar_Login", {
    domain: ".errepar.com",
    path: "/",
  });

  cookie.remove("MiErrepar_USR", {
    domain: ".errepar.com",
    path: "/",
  });
  
};


export { verifyCookie, deleteCookie };
